import { Component, OnInit, Input } from '@angular/core';
import { ProjectService } from '../../../api/services/project.services';
import { AuthService } from '../../../api/services/auth.service';
import { Worksheet } from '../../../api/models/worksheet';
import { Delegation } from '../../../api/models/delegation';

@Component({
  selector: 'app-project-name',
  templateUrl: './project-name.component.html',
  styleUrls: ['./project-name.component.scss']
})

export class ProjectNameComponent implements OnInit {

  @Input() projectTypeCode: string;
  @Input() projectId: string;

  nonExistingProject: string;

  projectName: string;
  delegation: Delegation = new Delegation();

  constructor(
    private projectService: ProjectService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    switch (this.projectTypeCode) {
      case 'WORKSHEET':
        this.projectService.getProjectNameForWorksheet(this.projectId).subscribe(projectName => this.projectName = projectName);
        break;
      case 'DELEGATION':
        this.authService.getDelegationByDelegationId(this.projectId).subscribe(delegation => {
          this.delegation = delegation
        });
        break;
      default:
        this.nonExistingProject = "There is no project name with that id!!!"
        break;
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/approvals/project-name/project-name.component.ts